export const CATALOG_FILTERS_OPTIONS_SHOW_COUNT = 5;
export const CATALOG_FILTERS_TYPE_COLOR = 'color';
export const CATALOG_FILTERS_TYPE_RANGE = 'range';
export const CATALOG_FILTERS_TYPE_COMMON = 'common';

export const CATALOG_PRODUCT_POINTS_URL = '/shop/getdeliveryandpaymentoffices/';

export const REQUEST_CATALOG_PRODUCTS = 'Catalog::RequestProductsList';
export const REQUEST_CATALOG_PRODUCTS_SUCCESS = 'Catalog::RequestProductsList::Success';
export const REQUEST_CATALOG_SHOW_MORE_LOADING = 'Catalog::RequestShowMore::Loading';
export const REQUEST_CATALOG_PRODUCTS_ERROR = 'Catalog::RequestProductsList::Error';
export const REQUEST_CATALOG_PRODUCTS_APPLY = 'Catalog::RequestProductsList::Apply';
export const REQUEST_CATALOG_PRODUCTS_APPLIED = 'Catalog::RequestProductsList::Applied';

export const REQUEST_CATALOG_PRODUCT_OFFICES = 'Catalog::RequestProductOffices';
export const REQUEST_CATALOG_PRODUCT_OFFICES_SUCCESS = 'Catalog::RequestProductOffices::Success';
export const REQUEST_CATALOG_PRODUCT_OFFICES_ERROR = 'Catalog::RequestProductOffices::Error';
export const CATALOG_PRODUCTS_READY_TO_SWITCH = 'Catalog::Products::ReadyToSwitch';

export const DELIVERY_TAKEAWAY_OFFICE = 'op';
export const DELIVERY_TAKEAWAY_PICKUP = 'pick_up_point';
export const DELIVERY_TAKEAWAY_POSTAMATE = 'parcel_automat';

export const CATALOG_UPDATE_ERROR_EMPTY = 'empty';
export const CATALOG_UPDATE_ERROR_UNEXPECTED = 'unexpected';

export const CATALOG_MAX_PRICE = 999999;

export const SUBSCRIBED_PRODUCT = 'Catalog::SubscribedProduct';
export const SET_IS_FAVORITE_PRODUCTS = 'Catalog::SET_IS_FAVORITE_PRODUCTS';
export const SET_IS_COMPARE_PRODUCTS = 'Catalog::SET_IS_COMPARE_PRODUCTS';
export const ERROR_CLASSNAME = 'error';
export const INFO_CLASSNAME = 'info';
export const UP_EMOJI = 'up';
export const STATUS_FAIL_EMOJI = 'statusFail';

export const POINT_TYPES = {
  parcel_automat: true,
  pick_up_point: true,
};
